/**
 * Tiny pluralization helper used in UI copy.
 *
 * Supports a couple of common patterns:
 * - `plural(1, ['1 item', '# items'])` -> "1 item"
 * - `plural(2, ['1 item', '# items'])` -> "2 items"
 *
 * Optional 3-form variant:
 * - `plural(0, ['No items', '1 item', '# items'])` -> "No items"
 * - `plural(1, ['No items', '1 item', '# items'])` -> "1 item"
 * - `plural(3, ['No items', '1 item', '# items'])` -> "3 items"
 *
 * The chosen string may include `#` which will be replaced with the number.
 *
 * The wuchale transform rewrites the `forms` literal into a catalog lookup that yields `[]`
 * when the catalog has no entry (e.g. under vitest, where no catalog is loaded), so a
 * missing form falls back to the bare number instead of throwing.
 */
export function plural(
  count: number,
  forms: [singular: string, plural: string] | [zero: string, singular: string, plural: string],
): string {
  const n = typeof count === "number" && Number.isFinite(count) ? count : 0;

  const template =
    forms.length === 3
      ? n === 0
        ? forms[0]
        : n === 1
          ? forms[1]
          : forms[2]
      : n === 1
        ? forms[0]
        : forms[1];

  return (template ?? "#").replace(/#/g, String(n));
}

export default plural;
